import { MenuItem, Select, TextField } from "@mui/material";
import type { GridTypeFilterInputValueProps } from "@mui/x-data-grid-premium";
import React from "react";

export const BetweenComponent = (props: GridTypeFilterInputValueProps) => {
  const [value1, value2] = Array.isArray(props.item.value)
    ? props.item.value
    : [null, null];
  return (
    <>
      <TextField
        variant="outlined"
        size="small"
        sx={{ pb: 1 }}
        label="Min"
        value={value1 ?? ""}
        onChange={(event) => {
          props.applyValue({
            ...props.item,
            value: [event.target.value, value2],
          });
        }}
      />
      <TextField
        variant="outlined"
        size="small"
        label="Max"
        value={value2 ?? ""}
        onChange={(event) => {
          props.applyValue({
            ...props.item,
            value: [value1, event.target.value],
          });
        }}
      />
    </>
  );
};

export const PrioritizedComponent = (props: GridTypeFilterInputValueProps) => {
  const value =
    props.item.value === "true" || props.item.value === "false"
      ? props.item.value
      : "";

  return (
    <Select
      variant="outlined"
      size="small"
      value={value}
      onChange={(event) => {
        props.applyValue({
          ...props.item,
          value: event.target.value,
        });
      }}
    >
      <MenuItem value="true">Yes</MenuItem>
      <MenuItem value="false">No</MenuItem>
    </Select>
  );
};
